import { createReducer } from '@reduxjs/toolkit';

import getCountriesList from '../../thunks/general/getCountriesList';

const initialState = {
  loading: false,
  error: null,
  list: [],
};

const getCountriesListReducer = createReducer(initialState, {
  [getCountriesList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCountriesList.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    list: data.map(({ country_name: name, country_code: code }) => ({ label: name, value: code })),
    loading: false,
  }),
  [getCountriesList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCountriesListReducer;
